import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { ICONS } from '@core/services/icons/icons.service';

import { altKeyLabelKey } from './alt-key';
import { EditDrag, EditPlacing } from './timeline-edit.service';

/** Says in words what dropping or placing the carried stop will do, and how to get out of it. */
@Component({
  selector: 'app-timeline-edit-strip',
  imports: [TranslatePipe],
  templateUrl: './timeline-edit-strip.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: ``
})
export class TimelineEditStripComponent {
  readonly drag = input<EditDrag | null>(null);
  readonly placing = input<EditPlacing | null>(null);

  protected readonly ICONS = ICONS;
  protected readonly altKey = altKeyLabelKey();
}
